import { useCallback, useMemo, useState } from 'react';
import { useCombobox, useMultipleSelection } from 'downshift';
import useFilteredItems from './useFilteredItems';
import { defaultLabelGetter } from '../helpers';
export const defaultCreateItem = label => ({
  label,
  value: label
});
export default (_ref => {
  let {
    items: itemsProp,
    initialInputValue,
    initialCreatedItems = [],
    createItem = defaultCreateItem,
    itemToString = defaultLabelGetter,
    getFilteredItems
  } = _ref;
  const [isMultiple, setIsMultiple] = useState(false);
  const [internalInputValue, setInternalInputValue] = useState(initialInputValue);
  const [createdItems, setCreatedItems] = useState(initialCreatedItems);
  const itemsWithCreated = useMemo(() => createdItems.concat(itemsProp), [createdItems, itemsProp]);
  const {
    filteredItems: exactMatchingItems
  } = useFilteredItems({
    items: itemsWithCreated,
    itemToString,
    getFilteredItems,
    inputValue: internalInputValue,
    filterBy: (item, inputValue) => item === inputValue
  });
  const creatableItem = useMemo(() => !internalInputValue || exactMatchingItems.length > 0 ? undefined : createItem(internalInputValue), [createItem, exactMatchingItems.length, internalInputValue]);
  const allItems = useMemo(() => creatableItem ? itemsWithCreated.concat(creatableItem) : itemsWithCreated, [creatableItem, itemsWithCreated]);
  const getCreatableItemProps = useCallback(() => ({
    value: internalInputValue || ''
  }), [internalInputValue]);
  const stateReducer = useCallback((state, _ref2) => {
    let {
      type,
      changes
    } = _ref2;
    switch (type) {
      case useCombobox.stateChangeTypes.InputChange:
        setInternalInputValue(changes.inputValue);
        return changes;
      case useCombobox.stateChangeTypes.ItemClick:
      case useCombobox.stateChangeTypes.InputKeyDownEnter:
      case useCombobox.stateChangeTypes.FunctionSelectItem:
        if (isMultiple) {
          return changes;
        }
        // remove all unselected created items
        setCreatedItems(prev => {
          return prev.filter(item => item === changes.selectedItem);
        });
        if (creatableItem && changes.selectedItem === creatableItem) {
          // move creatable item to created items
          setCreatedItems(prev => [creatableItem, ...prev]);
          setInternalInputValue(undefined);
        }
        return changes;
      default:
        return changes;
    }
  }, [creatableItem, isMultiple]);
  const multipleSelectionStateReducer = useCallback((state, _ref3) => {
    var _changes$selectedItem;
    let {
      type,
      changes
    } = _ref3;
    setIsMultiple(true);
    switch (type) {
      case useMultipleSelection.stateChangeTypes.FunctionAddSelectedItem:
        if (creatableItem && (_changes$selectedItem = changes.selectedItems) !== null && _changes$selectedItem !== void 0 && _changes$selectedItem.includes(creatableItem)) {
          // move creatable item to created items
          setCreatedItems([creatableItem, ...createdItems]);
        }
        break;
      case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
        // remove unselected creatable items
        setCreatedItems(prev => prev.filter(item => {
          var _changes$selectedItem2;
          return (_changes$selectedItem2 = changes.selectedItems) === null || _changes$selectedItem2 === void 0 ? void 0 : _changes$selectedItem2.includes(item);
        }));
        break;
      default:
        break;
    }
    return changes;
  }, [creatableItem, createdItems]);
  return {
    items: allItems,
    initialInputValue,
    creatableItem,
    getCreatableItemProps,
    getFilteredItems,
    stateReducer,
    multipleSelectionStateReducer
  };
});
//# sourceMappingURL=useCreatableItem.js.map